export const HUB_TYPES = {
    PROJECT_MANAGEMENT: 'ProjectManagement',
    VENDOR: 'Vendor',
    CUSTOMER: 'Customer',
};

export function getHubPrefix(organizationType) {
    switch (organizationType) {
        case HUB_TYPES.VENDOR:
            return 'vendor';
        case HUB_TYPES.CUSTOMER:
            return 'customer';
        default:
            return 'app';
    }
}

export function getHubRoute(organization) {
    if (!organization?.id) {
        return '/hubs';
    }

    const prefix = getHubPrefix(organization.organization_type);
    return `/${prefix}/${organization.id}`;
}

export function getHubProfilePath(organization) {
    if (!organization?.id) {
        return '/hubs';
    }
    return `${getHubRoute(organization)}/profile`;
}

export function getHubMismatchRedirect(organization, hubPrefix) {
    if (!organization?.id) {
        return '/login';
    }
    if (getHubPrefix(organization.organization_type) === hubPrefix) {
        return null;
    }
    return getHubRoute(organization);
}

export function flattenAccessibleOrganizations(organizations) {
    const rows = Array.isArray(organizations) ? organizations : [];
    const result = [];
    rows.forEach((org) => {
        result.push(org);
        (org.managed_organizations || []).forEach((child) => result.push(child));
    });
    return result;
}

export function shouldShowOrganizationSwitcher(orgCount) {
    return Number(orgCount) > 1;
}

export function getHubTypeLabel(organizationType, t) {
    switch (organizationType) {
        case HUB_TYPES.VENDOR:
            return t('hubs.vendorProfile');
        case HUB_TYPES.CUSTOMER:
            return t('hubs.customerProfile');
        default:
            return t('hubs.organization');
    }
}

export function getCustomerProjectLabel(project) {
    if (!project) return '';
    return project.location || project.name || String(project.id ?? '');
}

export function customerHubPath(orgId) {
    return `/customer/${orgId}`;
}

export function customerProjectPath(orgId, projectId) {
    return `/customer/${orgId}/projects/${projectId}`;
}

export function customerProjectDetailsPath(orgId, projectId) {
    return `/customer/${orgId}/projects/${projectId}/details`;
}

export function customerProjectTransactionsPath(orgId, projectId, search = {}) {
    const path = `/customer/${orgId}/projects/${projectId}/transactions`;
    const params = new URLSearchParams();
    Object.entries(search).forEach(([key, value]) => {
        if (value === '' || value == null) return;
        params.set(key, String(value));
    });
    const qs = params.toString();
    return qs ? `${path}?${qs}` : path;
}

export function customerProjectInvoicesPath(orgId, projectId) {
    return `/customer/${orgId}/projects/${projectId}/invoices`;
}

export function vendorHubPath(orgId) {
    return `/vendor/${orgId}`;
}

export function vendorQuotePath(orgId, projectId) {
    return `/vendor/${orgId}/quotes/${projectId}`;
}

export function vendorLinkedCompaniesPath(orgId) {
    return `/vendor/${orgId}/companies`;
}

export function vendorBusinessProfilePath(orgId) {
    return `/vendor/${orgId}/business`;
}
